import { Input, Button } from "antd";
import { useState } from "react";

const PromocodeSection = ({ promoCode, setPromoCode }) => {
  const [inputValue, setInputValue] = useState("FLAT20");
  return (
    <div className="promocode-section">
      <Input
        placeholder="Enter discount code here"
        className="promo-input"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        disabled={true}
      />
      <Button
        className="promo-apply-btn"
        onClick={() => setPromoCode(inputValue)}
      >
        {promoCode ? "Applied" : "Apply"}
      </Button>
    </div>
  );
};

export default PromocodeSection;
